// API Reference: https://www.wix.com/corvid/reference
// “Hello, World!” Example: https://www.wix.com/corvid/hello-world

import wixData from 'wix-data';
import wixLocation from 'wix-location';

// ID of the currently selected supplier type (from the side repeater)
let selectedType;

// Name of the selected language from the dropdown
let lang;

// Whether to show only virtual / non virtual suppliers
let virtual;

$w.onReady(async function () {
	let type = wixLocation.query.type;
	if (type) {
		// preselect a category from the url query
		selectedType = type;
		updateFilter()
		$w('#suppliersRepeater').expand()
		$w('#button4').expand()
	}

	let langOptions = (await wixData.query('Languages').find()).items.map(i=>({label: i.title, value: i._id}));
	$w('#langDropdown').options = langOptions;
});

export function supplierTypesRepeater_itemReady($item, itemData, index) {
	if(selectedType === itemData._id) {
		// preselect the button if the type was selected via query
		$item('#supplierTypeButton').style.backgroundColor = '#E6B1CF';
	}
	$item('#supplierTypeButton').onClick(()=>{
		if (selectedType === itemData._id) {
			// deselect and remove the filter
			$item('#supplierTypeButton').style.backgroundColor = 'white';
			selectedType = undefined;
			$w('#suppliersRepeater').collapse()
			$w('#button4').collapse()
		} else {
			// change the selected type to the clicked button
			$w('#supplierTypesRepeater').forEachItem(($i)=>{
				$i('#supplierTypeButton').style.backgroundColor = 'white';
			})
			$item('#supplierTypeButton').style.backgroundColor = '#E6B1CF';
			selectedType = itemData._id;
			$w('#suppliersRepeater').expand()
			$w('#button4').expand()
		}
		updateFilter()
	});
}

/**
 * Updates the filter of the suppliers dataset due to any changes to the dropdowns / type selector on the side
 */
function updateFilter() {
	let filter = wixData.filter();
	if (selectedType) {
		filter = filter.eq('type', selectedType)
	}
	if (lang) {
		filter = filter.hasSome('languages', [lang])
	}
	if (virtual !== undefined) {
		filter = filter.eq('onLine', virtual);
	}
	$w('#suppliersDataset').setFilter(filter);
}

export function langDropdown_change(event) {
	let selectedLang = $w('#langDropdown').value;
	if (selectedLang === 'all') {
		selectedLang = undefined;
		// remove the 'all' option from the dropdown
		$w('#langDropdown').selectedIndex = undefined
		$w('#langDropdown').options = $w('#langDropdown').options.slice(1);
	} else {
		// add an 'all' option to the dropdown
		if (lang === undefined) {
			$w('#langDropdown').options = [{label: 'כל השפות',value: 'all'},...$w('#langDropdown').options];
		}
	}
	if (lang !== selectedLang) {
		lang = selectedLang;
		updateFilter()
	}
}

export function isVirtualDropdown_change(event) {
	let selected = $w('#isVirtualDropdown').value;
	if (selected === 'all') {
		selected = undefined;
		// remove the 'all' option from the dropdown
		$w('#isVirtualDropdown').selectedIndex = undefined
		$w('#isVirtualDropdown').options = $w('#isVirtualDropdown').options.slice(1);
	} else {
		selected = selected === 'true';
		if (virtual === undefined) {
			// add an 'all' option to the dropdown
			$w('#isVirtualDropdown').options = [{label: 'הכל',value: 'all'},...$w('#isVirtualDropdown').options];
		}
	}
	if (virtual !== selected) {
		virtual = selected;
		updateFilter()
	}
}

export async function suppliersRepeater_itemReady($item, itemData, index) {
	$item('#isVirtual').text = itemData.onLine ? 'כן' : 'לא';

	let langs = await wixData.queryReferenced('Suppliers', itemData, 'languages');
	$item('#languagesText').text = langs.items.map(l=>l.title).join(', ');
	$item('#languagesText').show();

	if (itemData.video2) {
        $item('#videoPlayer1').expand()
    }
	if (itemData.video1) {
		$item('#videoPlayer2').expand()
	}
	if (itemData.docs) {
		$item('#iconButton3').expand()
	}
	if (itemData.web) {
		$item('#iconButton1').expand()
	}
	if (itemData.facebook) {
		$item('#iconButton2').expand()
	}
}

export function expandSupplier_click(event) {
	let $item = $w.at(event.context);
	$item('#expandSupplier').hide();
	$item('#extendedSupplier').expand();
	$item('#collapseSupplier').show();
}

export function collapseSupplier_click(event) {
	let $item = $w.at(event.context);
	$item('#collapseSupplier').hide();
	$item('#extendedSupplier').collapse();
	$item('#expandSupplier').show();
}

